var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"ClHkDX1yjGsWZy8ipvWkK"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs'
import { SENTRY_ALLOWED_PATHS, SENTRY_TRACES_SPANS_PATHS } from '@constants/common'

Sentry.init({
	dsn: process.env.NEXT_PUBLIC_SENTRY_DNS,
	enabled: process.env.NODE_ENV === 'production',
	release: `${process.env.NEXT_PUBLIC_SENTRY_PROJECT}@${process.env.APP_VERSION}`,
	// Setting this option to true will print useful information to the console while you're setting up Sentry.
	debug: false,

	// Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
	// tracesSampleRate: 1,

	/** 성능 추적에 필요한 페이지 필터 (트랜젝션을 페이지별로 수집) */
	tracesSampler: (samplingContext) => {
		if (typeof window !== 'undefined') {
			const currentPath = window.location.pathname
			const isAllowed = SENTRY_TRACES_SPANS_PATHS.some((path) => currentPath.startsWith(path))
			if (isAllowed) {
				return 1.0 // 100% 수집
			}

			// 중요하지 않은 페이지는 1%만 수집
			return 0.01
		}

		// 기본 샘플링 비율 (SSR 시점 등)
		return 0.01
	},

	/** 허용할 Page 등록 */
	beforeSend(event) {
		if (typeof window !== 'undefined') {
			const currentPath = window.location.pathname
			const isAllowed = SENTRY_ALLOWED_PATHS.some((path) => currentPath.startsWith(path))

			if (!isAllowed) return null
		}

		return event
	},
	beforeBreadcrumb(breadcrumb) {
		if (typeof window !== 'undefined') {
			const currentPath = window.location.pathname
			const isAllowed = SENTRY_ALLOWED_PATHS.some((path) => currentPath.startsWith(path))

			if (!isAllowed) return null
		}
		return breadcrumb
	},

	// /** 허용 URL */
	// allowUrls: [
	// 	/^https:\/\/news\.jtbc\.co\.kr(\/.*)?$/, // https://news.jtbc.co.kr
	// ],

	// /** 제한 URL */
	// denyUrls: [
	// 	/^https:\/\/local-news\.jtbc\.co\.kr(\/.*)?$/, // https://local-news.jtbc.co.kr
	// 	/^https:\/\/stg-news\.jtbc\.co\.kr(\/.*)?$/, // https://stg-news.jtbc.co.kr
	// 	/^https:\/\/dev-news\.jtbc\.co\.kr(\/.*)?$/, // https://dev-news.jtbc.co.kr
	// ],
})
